import styled from 'styled-components';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { isTablet } from 'react-device-detect';
import { pwaStyleAdapter } from '../../../utils/mobileSupported';

export const HeaderContainer = styled.div`
  position: absolute;
  top: -3px;
  left: -1px;
  height: ${isTablet ? pwaStyleAdapter(4, 'rem') : '4rem'};
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  background-size: calc(100% + 2px) 100%;
  background-image: url(${assetSource(ASSET_KEY.FULL_MODAL_HEADER)});
  ${({ theme }) => theme}
`;

export const HighlightHeaderTitle = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
  margin-top: 5px;
  ${({ theme }) => theme}
`;

export const HighlightHeaderSubTitle = styled.div`
  font-size: 1rem;
  font-weight: 400;
  margin-top: -5px;
  margin-bottom: 5px;
`;

export const HeaderWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  ${({ theme }) => theme}
`;

export const HeaderHeight = styled.div`
  height: 4rem;
  ${({ theme }) => theme}
`;

export const SubTitle = styled.p`
  width: 100%;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 5px;
  font-weight: bold;
  ${({ theme }) => theme}
`;

export const HeaderTitleWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  font-size: 3vmin;
  font-weight: 500;
  margin-bottom: 3vmin;
  ${({ theme }) => theme}
`;

export const HeaderLightDivider = styled.img.attrs(({ dividerAsset }) => ({
  src: dividerAsset || assetSource(ASSET_KEY.PURCHASE_LIGHT_DIVIDER),
}))`
  position: absolute;
  width: 100%;
  top: 100%;
  pointer-events: none;
  left: 0px;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme}
`;

